import { watchNavbarMenu, watchDropdownMenuItems } from './lib/navbar';
import { addTestimonialVideoClickHandlers } from './lib/testimonial-video';
import { setupCarousels } from './lib/carousel';
import { watchScroll } from './lib/scroll';
import { handleStoreNoticeDismiss } from './lib/store-notice';
import { handleConditionalFormFields } from './lib/wholesale';
import { setupPowerReviews } from './lib/power-reviews';

/**
 * Bootstrap 5 JS
 */
const bootstrap = require( 'bootstrap' );
window.bootstrap = bootstrap;

document.addEventListener( 'DOMContentLoaded', ( e ) => {
	/**
	 * Add scroll position indicator to html element
	 */
	watchScroll();
	/**
	 * Update navbar class on open, show first child
	 */
	watchNavbarMenu();
	/**
	 * Update featured image in dropdown menu on nav-item hover
	 */
	watchDropdownMenuItems();
	/**
	 * Add testimonial video click handlers
	 */
	addTestimonialVideoClickHandlers();
	/**
	 * Setup Carousels
	 */
	setupCarousels();
	/**
	 * Hide store notice on click
	 */
	handleStoreNoticeDismiss();
	/**
	 * Show/hide conditional wholesale registration fields
	 */
	handleConditionalFormFields();
	/**
	 * Add Power Reviews Support
	 */
	setupPowerReviews();
} );
